import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Table from "../../Common/Table";
import { InputAdornment, TextField } from "@material-ui/core";
import TableFields from "../../../constants/CapacityChange/CapacityChangeViewSlots.json";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import { bindActionCreators } from "redux";
import Errors from "../../../constants/Errors.json";
import SucessMessages from "../../../constants/SucessMessages.json";
import * as UserActions from "../../../store/actions/User";
import { isValNull } from "../../../utils";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../Common/Permission";

const CreateTab = ({
  slotData,
  createCapacityChangeRequest,
  setStatus,
  entityId,
}) => {
  const [capacityPercentageMapping, setCapacityPercentageMapping] = useState(
    {}
  );
  const allActions = MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE];
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    let values = {};
    (slotData || []).map((slot) => {
      values[slot.slot_capacity_id] = "0";
    });
    setCapacityPercentageMapping(values);
  }, [slotData]);

  const handleCapacityChange = (capacity_id, val) => {
    const values = { ...capacityPercentageMapping };
    values[capacity_id] = val;
    setCapacityPercentageMapping(values);
  };

  const checkIfButtonDisabled = (type) => {
    for (const [capacity_id, percentage] of Object.entries(
      capacityPercentageMapping
    )) {
      if (!isPercentageAcceptable(percentage)) {
        return true;
      }
    }
    return false;
  };

  const showNewCapacity = (capacity_id, total_capacity) => {
    let percentage = capacityPercentageMapping[`${capacity_id}`];
    if (isPercentageAcceptable(percentage)) {
      return Math.floor(total_capacity + (total_capacity * percentage) / 100);
    } else {
      return total_capacity;
    }
  };

  const clearCapacitiesPercentage = () => {
    let values = { ...capacityPercentageMapping };
    for (const key in values) {
      values[key] = 0;
    }
    setCapacityPercentageMapping(values);
  };

  const submitRequest = () => {
    let requestArray = [];
    for (const [capacity_id, percentage] of Object.entries(
      capacityPercentageMapping
    )) {
      if (isPercentageAcceptable(percentage) && percentage != 0) {
        requestArray.push({
          slot_capacity_id: parseInt(capacity_id),
          capacity_change_percentage: parseInt(percentage),
        });
      }
    }
    if (!isValNull(requestArray)) {
      setLoadingBtn(true);
      createCapacityChangeRequest(requestArray, entityId).then((res) => {
        setLoadingBtn(false);
        if (res) {
          setStatus({
            type: "success",
            message: SucessMessages.CREATION_SUCCESS,
          });
        } else {
          setStatus({ type: "error", message: Errors.GENERAL_ERROR });
        }
      });
    }
  };

  const isPercentageAcceptable = (value) => {
    return Number.isInteger(parseInt(value)) && value >= -75 && value <= 2000;
  };

  const getFieldValue = (slot_data, key) => {
    switch (key) {
      case "slot_name": {
        return <div style={{ width: "400px" }}>{slot_data[key]}</div>;
      }
      case "change_percentage":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              style={{ width: "40%" }}
              defaultValue={0}
              error={
                !isPercentageAcceptable(
                  capacityPercentageMapping[slot_data.slot_capacity_id]
                )
              }
              onChange={(e) =>
                handleCapacityChange(slot_data.slot_capacity_id, e.target.value)
              }
              variant="outlined"
              fullWidth
              value={capacityPercentageMapping[slot_data.slot_capacity_id]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">%</InputAdornment>
                ),
              }}
            />
            <div style={{ color: "red", marginLeft: "10px" }}>
              {isPercentageAcceptable(
                capacityPercentageMapping[slot_data.slot_capacity_id]
              )
                ? " "
                : "Range allowed between -75% to 2000%"}
            </div>
          </div>
        );
      case "new_capacity":
        return (
          <b>
            {showNewCapacity(
              slot_data.slot_capacity_id,
              slot_data.total_capacity ? slot_data.total_capacity : 0
            )}
          </b>
        );
      case "total_capacity":
        return <span>{!isValNull(slot_data[key]) ? slot_data[key] : "0"}</span>;
      default:
        return slot_data[key];
    }
  };

  return (
    <div style={{ display: "block" }}>
      <Table
        list={slotData}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      {slotData.length > 0 ? (
        <FlexContainer
          align={"flex-end"}
          justify={"right"}
          style={{ marginTop: "7px" }}
        >
          <Button
            data-testid="SlotsFiltersApply"
            type="clear"
            className="sushi-btn mr-10"
            appearance="outline"
            onClick={clearCapacitiesPercentage}
          >
            Clear
          </Button>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              disabled={checkIfButtonDisabled("submit")}
              data-testid="submitCapacityChangeRequest"
              type="submit"
              className="sushi-btn mr-10"
              appearance="filled"
              onClick={submitRequest}
              loading={loadingBtn}
            >
              Submit
            </Button>
          </Permission>
        </FlexContainer>
      ) : null}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(CreateTab);
